import { useState, useEffect } from "react";
import styles from "./styles.module.css";
import { db } from "../../firebase";

export default function Email({ email = {}, appId }) {
  const [_email, setEmail] = useState(null);
  const [change, setChange] = useState(false);

  useEffect(() => {
    setEmail(email);
  }, [email]);

  const handleSave = () => {
    db.collection("apps").doc(appId).set({ email: _email }, { merge: true });
    setChange(false);
  };

  const handleChange = (key, value) => {
    setEmail({ ..._email, [key]: value });
    setChange(true);
  };

  if (!_email) {
    return null;
  }

  return (
    <div className={styles.paper}>
      <div className={styles.subtitle}>Sender Settings</div>
      <div className={styles.inputTitle}>From Email Address</div>
      <input
        onChange={(e) => handleChange("address", e.target.value)}
        value={email.address}
        className={"input"}
        style={{ maxWidth: 360, marginBottom: 20 }}
      />
      <div className={styles.inputTitle}>Sendgrid API key</div>
      <input
        onChange={(e) => handleChange("apikey", e.target.value)}
        value={email.apikey}
        className={"input"}
        style={{ marginBottom: 20 }}
      />
      <div className={styles.inputTitle}>Sendgrid Template Id</div>
      <input
        onChange={(e) => handleChange("template", e.target.value)}
        value={email.template}
        className={"input"}
        style={{ maxWidth: 360 }}
      />
      {change && (
        <div>
          <button onClick={handleSave} className={styles.cardButton}>
            Save Changes
          </button>
        </div>
      )}
    </div>
  );
}
